import React, { useContext, useState } from 'react';
import { PayloadContext } from '../../context';
import HomeLayout from '../Layouts/homeLayout';
import LoadingView from '../Loader/LoadingView';
import PlanA from './components/plana';
import PlanB from './components/planb';
import PlanC from './components/planc';
import PersonalConferenceRoom from './components/personalConferenceRoom';
import BasicProConferenceRoom from './components/BasicProConferenceRoom';
import BasicConferenceRoom from './components/BasicConferenceRoom';
import KnoxEcartConferenceRoom from './components/KonxEcartConferenceRoom';
import SalesEcartConferenceRoom from './components/SalesEcartConferenceRoom';
import EnterpriseConferenceRoom from './components/EnterpriseConferenceRoom';
import BusinessConferenceRoom from './components/BusinessConferenceRoom';
import CorporateConferenceRoom from './components/CorporateConferenceRoom';
import { Button } from '@mui/material';
import { PORTAL } from '../../config';
import CustomPlan from './components/CustomPlan';
// import { useHistory } from 'react-router-dom';

const ActivationPage = () =>
{
	const { payload } = useContext(PayloadContext);
	const [ pack, setPack ] = useState('');

	// eslint-disable-next-line no-console
	// console.log('payload', payload);

	// const history = useHistory();

	// const handleBack = () =>
	// {
	// 	history.push('/dashboard');
	// };
	const renderPlanComponent = (planId) =>
	{
		switch (planId)
		{
			case 'planA':
				return <PlanA planId={planId} />;
			case 'planB':
				return <PlanB planId={planId} />;
			case 'planC':
				return <PlanC planId={planId} pack={pack} setPack={setPack} />;
			case 'customerPlanA':
				return <PersonalConferenceRoom planId={planId} />;
			case 'customerPlanB':
				return <BasicConferenceRoom planId={planId} />;
			case 'customerPlanC':
				return <BasicProConferenceRoom planId={planId} />;
			case 'customerPlanD':
				return <KnoxEcartConferenceRoom planId={planId} />;
			case 'EnterpriseRoom':
				return <EnterpriseConferenceRoom planId={planId} />;
			case 'BusinessRoom':
				return <BusinessConferenceRoom planId={planId} />;
			case 'CorporateRoom':
				return <CorporateConferenceRoom planId={planId} />;
			default:
				return <CustomPlan planId={planId} />;
		}
	};

	if (pack !== '')
	{
		return <PlanC planId='planC' pack={pack} setPack={setPack} />;
	}

	if (payload && payload.plan && payload.plan !== '')
	{
		return (<div className='d-flex flex-column w-100'>
			{payload.licenses?.length > 0
				? payload.licenses.map((item, index) => (
					<React.Fragment key={index}>
						{index>0?<hr/>:''}
						{renderPlanComponent(item.planId)}
					</React.Fragment>
				))
				: renderPlanComponent(payload.plan) // Render planA, planB, planC based on payload.plan if no customer plan matches
			}
			{/* {payload.licenses?.length > 0 && payload.plan!=='eCard'?
				<div className='pdngXS'>
					<div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM pdngSM mrgnTSM'>
						<h3 className='pdngXXS'>www.konx.biz</h3>
					</div>
				</div> :''
			} */}

		</div>);
	}
	else
	{
		return (<div id='root' className='d-flex flex-column alignCntr justifyCntr'>
			<p>You do not have any License </p>
			<a className='mt-2' href={`${PORTAL=='WORLD'?'https://www.konx.world/plans-and-pricing/':'https://www.konx.biz/plans-and-pricings/'}`} target='_blank' rel='noreferrer'><Button className='mt-3' variant='contained' >  Order Now</Button></a>
		 </div>);
	}
};

export default HomeLayout(ActivationPage);